import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=62d483ae&scoped=true&"
import script from "./ModalBox.vue?vue&type=script&lang=ts&"
export * from "./ModalBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d483ae",
  null
  
)

export default component.exports